import React from 'react';

export default function PersonalAddress (props) {
  const { address, alias } = props;
  return (
    <div className="personal-address">
      <div className="container">
        <h2 className="threed" >{alias}</h2>
      </div>
      <div className="address">{address}</div>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/PersonalAddress.js